import { observer } from 'mobx-react-lite'
import PendingVisit from 'models/Provider/visits/PendingVisit'

type DischargeInstructionsList = {
  visit: PendingVisit
  isSuccess?: boolean
}

const DischargeInstructionsList = ({ visit, isSuccess }: DischargeInstructionsList) => {
  return visit?.dischargeInstructions?.list.map(({ name, filename }, i) => (
    <p className="typography-body-l" key={i}>
      {name}
      <a
        className="block text-primary-800"
        target="_blank"
        href={`https://timelymd-discharge-instructions.s3.us-east-2.amazonaws.com/${filename}`}
      >
        Open {isSuccess ? 'guide' : 'instructions'}
      </a>
    </p>
  ))
}

export default observer(DischargeInstructionsList)
